import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { hasPermission } from "../helpers/user";
import { useAuth } from "../providers/AuthProvider";
import { User } from "../types/User";

const Home = ({ me }: { me: User }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { getScopedPageUrl } = useAuth();

  useEffect(() => {
    const currentSearch = location.search;

    if (
      me.accountPermissions &&
      hasPermission(me.accountPermissions, "accessEmployer")
    ) {
      navigate(`${getScopedPageUrl("employerHome")}${currentSearch}`, {
        replace: true,
      });
    } else {
      navigate(`${getScopedPageUrl("viewDossiers")}${currentSearch}`, {
        replace: true,
      });
    }
  });

  return <div></div>;
};

export default Home;
